export default "__VITE_ASSET__C$DIGkGC__"